var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-block",style:(_vm.blockStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }